var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title:
          _vm.form.confirmType == 1 ? "订单开票二次确认" : "订单红冲二次确认",
        visible: _vm.dialogVisible,
        "close-on-click-modal": false,
        "append-to-body": true,
        width: "500px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.close,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "confirmForm",
          attrs: {
            model: _vm.form,
            "label-width": "100px",
            size: "small",
            rules: _vm.rules,
          },
        },
        [
          _c(
            "div",
            { staticClass: "flex flex-center margin-bottom-20 color-redFont" },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.form.confirmType == 1
                      ? "确认后开票信息状态将改为开票【开票成功】"
                      : "确认后红冲信息状态将改为红冲【开具成功】"
                  ) +
                  "\n    "
              ),
            ]
          ),
          _vm.form.confirmType == 1
            ? _c(
                "el-form-item",
                { attrs: { label: "发票号码", prop: "invoiceNo" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入20位数字发票号码",
                      maxlength: "20",
                      "show-word-limit": "",
                    },
                    on: { input: _vm.validateInvoiceNumber },
                    model: {
                      value: _vm.form.invoiceNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "invoiceNo", $$v)
                      },
                      expression: "form.invoiceNo",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.form.confirmType == 1
            ? _c(
                "el-form-item",
                { attrs: { label: "上传pdf" } },
                [
                  _c("FileUpload", {
                    ref: "upload",
                    attrs: {
                      list: _vm.form.fileList,
                      accept: ".pdf",
                      code: "work-order",
                      fileSize: 2,
                      limit: 1,
                    },
                    on: { input: _vm.uploadSuccess },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            { attrs: { label: "反馈信息" } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 3,
                  placeholder: "请输入反馈信息（最多100字）",
                  maxlength: "100",
                  "show-word-limit": "",
                },
                model: {
                  value: _vm.form.feedback,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "feedback", $$v)
                  },
                  expression: "form.feedback",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.close } },
            [_vm._v("关闭")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small", loading: _vm.loading },
              on: { click: _vm.confirm },
            },
            [_vm._v("确认")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }